export const appsModules = [
    { hostnames: ["myconfig", "my-config"], module: "myconfig" },
    { hostnames: ["mysfc", "my-sfc"], module: "mysfc" },
    { hostnames: ["mydashboard", "my-dashboard"], module: "mydashboard" },
    { hostnames: ["myconnect", "my-connect"], module: "myconnect" },
    { hostnames: ["myind", "my-ind"], module: "myind" }
];

export function getCurrentModuleFromHostname(modules = appsModules) {
    const currentHostname = window.location.hostname.toLowerCase();
    const currentModule = modules.find(({ hostnames }) =>
        hostnames.some((hostname) => currentHostname.includes(hostname))
    );

    return currentModule?.module || "myconfig";
}

export function getMyWikiBaseUrl() {
    const origin = window.location.origin.toLowerCase();
    const prodURL = origin.includes("indsiders.com") && !origin.includes("dev") && !origin.includes("homolog");
    const homologURL = origin.includes("homolog");

    if (prodURL) return "https://mywiki-v2.indsiders.com";
    if (homologURL) return "https://mywiki-homolog.indsiders.com";

    return "https://mywiki-dev.indsiders.com";
}

export function getMyWikiUrl() {
    return `${getMyWikiBaseUrl()}/${getCurrentModuleFromHostname(appsModules)}`;
}
